<div class="home-page-container">
  <div class="app-gutters list-page-gutters">
    <div>
      <ng-container>
        <dxo-card [bodyHeader]="taxBodyHeader">
          <card-body>
            <div class="loader-container" *ngIf="isTaxLoading">
              <dxo-circular-loader text="Loading..." [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
            </div>
            <div>
              <dxo-table 
                [stickyColumn]="false" 
                [data]="taxDataTable">
              </dxo-table>
            </div>
          </card-body>
        </dxo-card>
      </ng-container>
    </div>

    <div>
      <ng-container>
        <dxo-card [bodyHeader]="scheduleAHeader">
          <card-body>
            <div class="loader-container" *ngIf="isLetterLoading; else showLetters">
              <dxo-circular-loader text="Loading..." [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
            </div>
            <div>
              <app-p8-documents-error-page
                  *ngIf="hasServerError"
                  [messageHeader]="messageHeader"
                  [messageBody]="messageBody"
                >
                </app-p8-documents-error-page>
            </div>
            <div>
              <ng-template #showLetters>
                <div class="parent" *ngIf="!hasServerError && !isLetterLoading">

                  <div id="letter-card" *ngIf="totalLines > 0">
                    
                        <div >
                          <dxo-table 
                            [stickyColumn]="false" 
                            [data]="scheduleADataTable">
                          </dxo-table>
                        </div>
                  </div>
                  <div class="nextline">
                    <dxo-accordion [showBottomBorder]="false" [showContent] = "!hasScheduleA" longTitle = "Request a custom Schedule A letter">
                      <accordion-content>
                        <div id="request-card">
                          <form [formGroup]="formGroup" (ngSubmit)="submit()" #myForm="ngForm">
                            <div class="data-containter">
                              <div class="dateLabel">Enter date range:</div>
                              <div class="row-input">
                                <div class="input-lable">Start date (MM/DD/YYYY)</div>
                                <div class="input-lable">End date (MM/DD/YYYY)</div>
                              </div>
                              <div class="row-input">
                                <dxo-text-input
                                  class="input-300"
                                  input-id="fromDate"
                                  [maxlength]="10"
                                  autocomplete="fromDay"
                                  type="date"
                                  [characterSet]="dateCharRegex"
                                  formControlName="fromDate"
                                  [errorControl]="formErrors.fromDate"
                                >
                                </dxo-text-input>
  
                                <dxo-text-input
                                  class="input-300"
                                  input-id="ToDate"
                                  [maxlength]="10"
                                  autocomplete="toDay"
                                  type="date"
                                  [characterSet]="dateCharRegex"
                                  formControlName="toDate"
                                  [errorControl]="formErrors.toDate"
                                >
                                </dxo-text-input>
                              </div>
                            </div>
                            <dxo-button
                              [primary]="true"
                              text="Submit request"
                              data-category="request"
                              data-action="Close Modal"
                              (handleClick)="request()"
                              [disabled]="formGroup.pristine"
                            >
                            </dxo-button>
                          </form>
                        </div>
                      </accordion-content>
                    </dxo-accordion>
                  </div>
                </div>
              </ng-template>
            </div>
          </card-body>
        </dxo-card>
      </ng-container>
    </div>
  </div>
</div>

<dxo-modal *ngIf="open && !modalSuccess" [shouldShowCloseX]="false">
  <modal-body class="loader-container">
    <dxo-circular-loader text="Loading..." [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
  </modal-body>
</dxo-modal>
<dxo-modal
  *ngIf="open && modalSuccess"
  title="We received your Schedule A request"
  [maxWidth]="470"
  [shouldShowCloseX]="false"
>
  <modal-body>
    <p>Thank you for your request. Processing the request may take two business days to complete.</p>
    <p>An email confirmation is on the way.</p>
    <dxo-button text="Close" color="blue" (handleClick)="closePopup()"></dxo-button>
  </modal-body>
</dxo-modal>
